import Api from '@/services/Api';
import store from '@/store';
//User api cals
export default {
  getDiscussionSubCommentsByCommentsId(params) {
    return Api().get('/powerguard/discussions-sub-comments', {
      params,
      headers: {
        Authorization: 'Bearer ' + store.getters.getToken,
      },
    });
  },
  //   getAllDiscussions() {
  //     return Api().get('/powerguard/discussions/', {
  //       headers: {
  //         Authorization: 'Bearer ' + store.getters.getToken,
  //       },
  //     });
  //   },
  //   saveQueryModification(credintials) {
  //     return Api().patch('/powerguard/query', credintials, {
  //       headers: {
  //         Authorization: 'Bearer ' + store.getters.getToken,
  //       },
  //     });
  //   },
  addNewSubComment(credintials) {
    return Api().post('/powerguard/discussion/sub-comment', credintials, {
      headers: {
        Authorization: 'Bearer ' + store.getters.getToken,
      },
    });
  },
  //   getQueryByCustomerId(credintials) {
  //     return Api().post('/powerguard/query-customer-id/', credintials, {
  //       headers: {
  //         Authorization: 'Bearer ' + store.getters.getToken,
  //       },
  //     });
  //   },
};
